export default __webpack_public_path__ + "static/4-efeb2176a03833b0439105e5e03893ef.webp";